import { ActivityIcon } from '@jouzen/ecom-components/icons/ActivityIcon';
import { CalendarIcon } from '@jouzen/ecom-components/icons/CalendarIcon';
import { SunriseIcon } from '@jouzen/ecom-components/icons/SunriseIcon';
import { TitaniumIcon } from '@jouzen/ecom-components/icons/TitaniumIcon';
import { TrendsIcon } from '@jouzen/ecom-components/icons/TrendsIcon';
import { WalkingIcon } from '@jouzen/ecom-components/icons/WalkingIcon';
import { type MessageKey } from 'types/LocaleMessageKey';
import { type SVGIconComponent } from 'types/svgr';

interface ActivityAndMovementTrackingHighlight {
  id: string;
  header: MessageKey;
  Icon: SVGIconComponent;
  content: MessageKey;
}

const activityAndMovementTrackingData: ActivityAndMovementTrackingHighlight[] =
  [
    {
      id: 'steps',
      header: 'activity_tracking_accordion_item_1_header',
      Icon: WalkingIcon,
      content: 'activity_tracking_accordion_item_1_content',
    },
    {
      id: 'calories',
      header: 'activity_tracking_accordion_item_2_header',
      Icon: ActivityIcon,
      content: 'activity_tracking_accordion_item_2_content',
    },
    {
      id: 'activity-tracking',
      header: 'activity_tracking_accordion_item_3_header',
      Icon: SunriseIcon,
      content: 'activity_tracking_accordion_item_3_content',
    },
    {
      id: 'add-and-edit',
      header: 'activity_tracking_accordion_item_4_header',
      Icon: CalendarIcon,
      content: 'activity_tracking_accordion_item_4_content',
    },
    {
      id: 'partner-devices',
      header: 'activity_tracking_accordion_item_5_header',
      Icon: TitaniumIcon,
      content: 'activity_tracking_accordion_item_5_content',
    },
    {
      id: '360-view',
      header: 'activity_tracking_accordion_item_6_header',
      Icon: TrendsIcon,
      content: 'activity_tracking_accordion_item_6_content',
    },
  ];

export default activityAndMovementTrackingData;
